import * as React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { useLoadLeagueData } from '../../../../app/dataLoaderHooks';
import { League } from '../../../../sdk/model';
import { Box, Typography, Select, MenuItem } from '@mui/material';
import RosterContractDisplay from '../../team/RosterContractDisplay';
import TeamSalaryInfo from '../../team/TeamSalaryInfo';
import DeadCapReport from '../../team/DeadCapReport';

interface manageContractsProps {
  league: League
}

function ManageContracts(props: manageContractsProps) {
  const [isLoadComplete, setLoadComplete] = React.useState(false);
  const [isException, setIsException] = React.useState(false);
  const [selectedTeamIndex, setSelectedTeamIndex] = React.useState(0);
  
  const user = useAppSelector((state) => state.user);
  
  const league : League|undefined = useLoadLeagueData({
      leagueId: props.league.id, 
      userId: user.id, 
      loadBasicDraftData: false,
      loadFullDraftData: false, 
      loadContractData: false,
      loadBasicAuctionData: false, 
      loadFullAuctionData: false,
      loadRosterData: true, 
      loadScheduleData: false, 
      loadWaivedContracts: false,
      isException, 
      setIsException, 
      isLoadComplete, 
      setLoadComplete
    });
  
  const playerDataLoad = useAppSelector((state) => state.playerDataLoad );
  
  const playerMap = new Map(playerDataLoad.flatMap(team => team.players).map((player) => [player.id, player]));
  
  if (!isLoadComplete) {
    return <Typography>Loading...</Typography>
  }
  
  const selectedTeam = league?.teams[selectedTeamIndex]!;
  const teamMap = new Map(league.teams.map(team => [team.id, team]));
  const activeContracts = new Set(Object.values(selectedTeam.playerRoster!).flat().concat(selectedTeam.practiceSquad || []).filter(player => player).map(player => player.contract?.id));
  const contractsWithPayments = new Set(Object.values(selectedTeam.paymentsBySeason!).flat().map(payment => payment.contractId!));
  const deadCapContractIds = [...contractsWithPayments].filter(contractId => !activeContracts.has(contractId));
  
  return <Box>
    <Select name="team" label="Team" labelId="teamLabel" value={selectedTeamIndex}
        onChange={event => setSelectedTeamIndex(Number(event.target.value))}>
      {league!.teams.map((team, teamIndex) => 
        <MenuItem key={teamIndex} value={teamIndex}>{league!.teams[teamIndex].name}</MenuItem>
      )}
    </Select>
    <TeamSalaryInfo salaryCap={league?.currentSeason?.nflSeason?.salaryCap!} currentSeasonSalary={selectedTeam.currentSeasonSalary!} />
    <RosterContractDisplay team={selectedTeam} myTeam={true} currentSeason={league?.currentSeasonYear!} otherTeamIds={[]}
          teamMap={undefined} proposalPlayerMap={undefined} playerMap={playerMap}
          handleTradeProposalChange={undefined} earliestLockDate={null} practiceSquad={false} showPracticeSquad={true} commish={true} />
    {deadCapContractIds.length > 0 &&
      <DeadCapReport deadCapContractIds={deadCapContractIds} teamId={selectedTeam.id!} currentSeason={league?.currentSeason?.seasonYear!} playerMap={playerMap} teamMap={teamMap} commish={true} />
    }
  </Box>
}

export default ManageContracts;
